import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { subadminService } from "../../services/SubadminServices";

const SubadminForm = () => {
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [permissions, setPermissions] = useState({
    dashboard: false,
    users: false,
    plans: false,
    subadmins: false,
    wallets: false,
    withdrawals: false,
    support: false,
    referrals: false,
    transactions: false,
  });

  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      fetchSubadmin();
    }
  }, [id]);

  const fetchSubadmin = async () => {
    try {
      const response = await subadminService.getSubadmin(id);
      if (response.status === 200) {
        const { fullName, email, phoneNumber, permissions } = response.data.data;
        setFullName(fullName);
        setEmail(email);
        setPhoneNumber(phoneNumber);
        setPermissions({
          dashboard: !!permissions.dashboard,
          users: !!permissions.users,
          plans: !!permissions.plans,
          subadmins: !!permissions.subadmins,
        });
      }
    } catch (error) {
      console.error("Failed to fetch subadmin:", error);
    }
  };

  const handlePermissionChange = (e) => {
    setPermissions({
      ...permissions,
      [e.target.name]: e.target.checked,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const subadminData = {
      fullName,
      email,
      phoneNumber,
      permissions,
    };

    if (!id) subadminData.password = password;

    try {
      if (id) {
        await subadminService.updateSubadmin(id, subadminData);
      } else {
        await subadminService.createSubadmin(subadminData);
      }
      navigate("/admin/subadmins");
    } catch (error) {
      console.error("Failed to save subadmin:", error);
    }
  };

  return (
    <>
      <div className="body-header border-bottom d-flex py-3">
        <div className="container-xxl">
          <div className="row align-items-center">
            <div className="col">
              <h1 className="h4 mt-1">{id ? "Edit Subadmin" : "Create New Subadmin"}</h1>
            </div>
          </div>
        </div>
      </div>

      <div className="body d-flex py-3">
        <div className="container-xxl">
          <div className="row align-item-center">
            <div className="col-md-12">
              <div className="card mb-3">
                <div className="card-header py-3 d-flex justify-content-between bg-transparent border-bottom-0">
                  <h6 className="mb-0 fw-bold">{id ? "Edit Subadmin" : "Create New Subadmin"}</h6>
                </div>
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row g-3 align-items-center">
                      <div className="col-md-6">
                        <label className="form-label">Full Name</label>
                        <input
                          type="text"
                          className="form-control"
                          value={fullName}
                          onChange={(e) => setFullName(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-md-6">
                        <label className="form-label">Phone No.</label>
                        <input
                          type="text"
                          className="form-control"
                          value={phoneNumber}
                          onChange={(e) => setPhoneNumber(e.target.value)}
                          required
                        />
                      </div>
                      {!id && (
                        <div className="col-md-6">
                          <label className="form-label">Password</label>
                          <input
                            type="password"
                            className="form-control"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                          />
                        </div>
                      )}
                      <div className="col-md-12">
                        <label className="form-label">Permissions</label>
                        <div className="row">
                          {["dashboard", "users", "plans", "subadmins", "wallets", "withdrawals", "support", "referrals", "transactions"].map((perm) => (
                            <div className="col-md-3" key={perm}>
                              <label className="form-check-label">
                                <input
                                  type="checkbox"
                                  name={perm}
                                  checked={permissions[perm]}
                                  onChange={handlePermissionChange}
                                  className="form-check-input me-2"
                                />
                                {perm.charAt(0).toUpperCase() + perm.slice(1)}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                    <button type="submit" className="btn btn-primary mt-4">
                      {id ? "Update" : "Create"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubadminForm;
